import { AccessDataProtectionComponent } from './component/AccessDataProtectionComponent';
import { WEB_COMPONENT_WIDGET_ACCESS_DATA_PROTECTION } from '../webcomponents.constants';

export { AccessDataProtectionComponent };

window.customElements.define(WEB_COMPONENT_WIDGET_ACCESS_DATA_PROTECTION, AccessDataProtectionComponent);
